<template>
  <div class="login-status">
    <div v-if="userInfo.uid">
      <div @click.stop="showMenu">
        <button class="login-success">
          <span>{{ userInfo.name }} {{ userInfo.firstName }}</span>
        </button>
        <img
          src="../../assets/images/down-arrow.svg"
          class="down-arrow-icon"
          @click.stop="showMenu"
        />
        <div class="dropdown-box" ref="dropDownMenu">
          <ul class="menu">
            <li
              v-for="(item, index) in menus"
              v-bind:key="index"
              @click="selectMenu(item.path)"
              :style="{
                display:
                  item.type == userInfo.type || item.type == 'all' ? '' : 'none'
              }"
            >
              <span>{{ item.title }}</span>
            </li>
          </ul>
          <!--<div class="separate"></div>-->
          <!--<div class="title">LANGUAGE</div>-->
          <!--<dropdown-menu-type-2 title="LANGUAGE"></dropdown-menu-type-2>-->
          <!--<div class="title">CURRENCY</div>-->
          <!--<dropdown-menu-type-2 title="CURRENCY"></dropdown-menu-type-2>-->
        </div>
      </div>
    </div>
    <div v-else>
      <div class="signup">
        <button @click.stop="popup('full', 'signup')">SIGN UP</button>
      </div>
      <div class="login">
        <button @click.stop="popup('full', 'login')">LOG IN</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  name: 'login-status',
  data() {
    return {
      menus: [
        // {title: 'Dashboard', path: 'dashboard', type: 'all'},
        { title: 'REQUEST', path: 'request', type: 'photographer' },
        { title: 'BOOKING', path: 'booking', type: 'all' },
        { title: 'SAVED', path: 'saved', type: 'user' },
        { title: 'MESSAGE', path: 'message', type: 'all' },
        { title: 'ALBUM', path: 'album', type: 'user' },
        { title: 'SERVICE', path: 'service', type: 'photographer' },
        { title: 'AVAILABILITY', path: 'availability', type: 'photographer' },
        { title: 'FEEDBACK', path: 'feedback', type: 'photographer' },
        { title: 'ACCOUNT', path: 'account', type: 'all' },
        { title: 'SIGN OUT', path: 'signout', type: 'all' }
      ]
    }
  },
  methods: {
    popup(type, component) {
      // console.log(component)
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: component,
        active: true,
        type: type
      })
    },
    logout() {
      this.$store.dispatch(types.LOGIN_OUT).then(() => {
        this.$router.push({ path: '/' })
      })
    },
    selectMenu(path) {
      if (path === 'signout') {
        this.logout()
        return
      }
      this.$router.push({ path: '/' + this.userInfo.type + '/' + path })
    },
    showMenu() {
      const dropdownBox = this.$refs.dropDownMenu // Binding child element.
      // console.log(dropdownBox)
      if (dropdownBox) {
        if (dropdownBox.className === 'dropdown-box') {
          // this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
          dropdownBox.classList.add('active')
          this.$forceUpdate()
        } else {
          dropdownBox.classList.remove('active')
        }
      }
    }
  },
  created() {
    // console.log('login status vue: ', this.$store.getters)
  },
  computed: {
    ...mapGetters(['userInfo'])
  }
}
</script>

<style lang="scss" scoped>
.login-status {
  margin: 0 10px 0 0;

  button {
    position: relative;
    cursor: pointer;
    color: #000bff;
    background-color: transparent;
    border: none;
    font-size: 14px;
    font-weight: 600;
  }

  .signup {
    display: inline;
    float: left;
    margin: 0 20px 0 0;
  }

  .login {
    display: inline;
    float: left;
  }

  .down-arrow-icon {
    cursor: pointer;
    width: 16px;
    height: 9px;
    position: relative;
  }

  .login-success {
    color: black;
  }

  .dropdown-box {
    top: -140px;
    width: 180px;
    visibility: hidden;
    opacity: 0;
    height: auto;
    z-index: -1;
    border: 1px solid #cbcbcb;
    background-color: #fff;
    position: absolute;
    right: -4px;
    padding: 10px;

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;

    &:before {
      position: absolute;
      top: -12px;
      right: 40px;
      z-index: 1001;
      content: '';
      width: 20px;
      height: 20px;
      border-top: 1px solid #cbcbcb;
      border-right: 1px solid #cbcbcb;
      transform: rotate(315deg);
      background-color: #fff;
    }

    .title {
      margin: 0 0 0 20px;
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.9px;
    }

    .separate {
      width: 80%;
      border-top: 1px solid gray;
      margin: 10px auto;
      position: relative;
    }

    .dropdown-menu-type-2 {
      height: 0;
      margin: 0 0 10px 20px;
      height: auto;
    }

    .menu {
      margin: 10px 0 0 20px;
      position: relative;
      width: 120px;
      /*border: 1px solid red;*/
      li {
        cursor: pointer;
        line-height: 40px;
      }
    }

    &.active {
      visibility: visible;
      opacity: 1;
      z-index: 1000;
      height: auto;
      top: 40px;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;

      /*.dropdown-menu-type-2 {*/
      /*height: auto;*/
      /*visibility: visible;*/
      /*opacity: 1;*/
      /*transition: all 0.1s;*/

      /*transition-property: width height background-color font-size left top transform transform color;*/
      /*transition-duration: 0.3s;*/
      /*transition-timing-function: ease-in-out;*/
      /*}*/
    }
  }
}
</style>
